
import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import PrivacyPolicy from "../pages/home/components/PrivacyPolicy";
import TermsOfService from "../pages/home/components/TermsOfService";
import ThankYouPage from "../pages/thank-you/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/privacy-policy",
    element: <PrivacyPolicy />,
  },
  {
    path: "/terms-of-service",
    element: <TermsOfService />,
  },
  {
    path: "/thank-you",
    element: <ThankYouPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
